var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "modal-h1 mb-3" }, [
      _c("button", {
        staticClass: "btn btn-back",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.$emit("cancel")
          }
        }
      }),
      _vm._v("\n    Create Customer\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { autocomplete: "no" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.create($event)
          },
          keydown: function($event) {
            _vm.clearError($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "l-bg-white" },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-6 pl-1 pr-1" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Company")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.companies,
                          placeholder: "Select Company"
                        },
                        model: {
                          value: _vm.customer.company_id,
                          callback: function($$v) {
                            _vm.$set(_vm.customer, "company_id", $$v)
                          },
                          expression: "customer.company_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "company_id" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-6 pl-1 pr-1" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("First name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.first_name,
                          expression: "customer.first_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Enter First Name",
                        autocomplete: "no"
                      },
                      domProps: { value: _vm.customer.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customer,
                            "first_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "first_name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 pl-1 pr-1" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Last name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.last_name,
                          expression: "customer.last_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Enter Last Name",
                        autocomplete: "no"
                      },
                      domProps: { value: _vm.customer.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customer,
                            "last_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "last_name" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-6 pl-1 pr-1" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.email,
                          expression: "customer.email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "email",
                        placeholder: "Enter Email",
                        autocomplete: "no"
                      },
                      domProps: { value: _vm.customer.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.customer, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "email" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 pl-1 pr-1" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Phone")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.phone,
                          expression: "customer.phone"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Enter Phone",
                        autocomplete: "no",
                        maxlength: "14"
                      },
                      domProps: { value: _vm.customer.phone },
                      on: {
                        keydown: _vm.maskPhone,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.customer, "phone", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "phone" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.customer.contacts, function(contact, index) {
              return _c("div", { key: contact.id }, [
                index === 0
                  ? _c("div", { staticClass: "row" }, [_vm._m(0, true)])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-5 pl-1 pr-1" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Email")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contact.email,
                              expression: "contact.email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "email",
                            placeholder: "Enter Email",
                            autocomplete: "no"
                          },
                          domProps: { value: contact.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(contact, "email", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: {
                          errors: _vm.errors,
                          field: "contacts." + index + ".email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-5 pl-1 pr-1" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Phone")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contact.phone,
                              expression: "contact.phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Enter Phone",
                            autocomplete: "no"
                          },
                          domProps: { value: contact.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(contact, "phone", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: {
                          errors: _vm.errors,
                          field: "contacts." + index + ".phone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-1 pr-0 pl-5 pt-3 text-right" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-clear p-1",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.removeContact(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-times" })]
                      )
                    ]
                  )
                ])
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn add-button",
                    attrs: { type: "button" },
                    on: { click: _vm.addAdditionalContact }
                  },
                  [
                    _vm._m(1),
                    _vm._v("\n            Add additional contact\n          ")
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md" },
                [
                  _c("error-field", {
                    staticClass: "mt-3",
                    attrs: { errors: _vm.errors, field: "authorization" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary float-right ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: { disabled: _vm.buttonDisabled }
                  },
                  [
                    _vm._v("\n            Create\n            "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ])
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-0" }, [
      _c("h4", [_vm._v("Additional Contacts")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fa fa-plus", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dbd5077", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbd5077","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/CustomersCreate.vue
// module id = null
// module chunks = 